import { cn } from "@/lib/utils"

type Props = {
  peaks: number[]
  progress: number
  isPlaying: boolean
  onClick?: (progress: number) => void
  className?: string
}

export function MiniWaveform({
  peaks,
  progress,
  isPlaying,
  onClick,
  className,
}: Props) {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!onClick) return
    e.preventDefault()
    e.stopPropagation()
    const rect = e.currentTarget.getBoundingClientRect()
    const x = e.clientX - rect.left
    const clickProgress = Math.max(0, Math.min(1, x / rect.width))
    onClick(clickProgress)
  }

  const playedBars = Math.floor(peaks.length * progress)

  return (
    <div
      className={cn(
        "flex items-end gap-px h-8",
        onClick && "cursor-pointer",
        className
      )}
      onClick={handleClick}
    >
      {peaks.map((peak, i) => (
        <div
          key={i}
          className={cn(
            "flex-1 rounded-sm transition-colors duration-75",
            i < playedBars ? "bg-red-500" : "bg-muted-foreground/40"
          )}
          style={{ height: `${Math.max(peak * 100, 8)}%` }}
        />
      ))}
    </div>
  )
}
